import React from 'react';

import { VideoWrapper } from './styles/Components';

export const Video = ({ url }: { url: string }) => (
  <VideoWrapper autoPlay muted loop playsinline disablePictureInPicture>
    <source src={url} type="video/mp4"></source>
  </VideoWrapper>
);
